import React from 'react';
import pick from 'lodash/pick';
import cs from 'classnames';
import css from './index.css';

const pickDOMprops = (props) => pick(props, [
  'checked',
  'onBlur',
  'onChange',
  'onDragStart',
  'onDrop',
  'onFocus',
  'value',
]);

const Checkbox = (props) => (
  <label className={cs(props.wrapClassName, css.wrap, {[css.checked]: props.checked || !!props.value , [props.checkedClassName]: props.checked || !!props.value})}>
    <input type='checkbox' {...pickDOMprops(props)} value={!!props.value}  className={cs(props.qa, {[`${props.qa}-checked`]: props.checked})}/>
    <div className={cs(css.label,props.labelClassName)}>
      {props.children}
    </div>
  </label>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/index.js